import { render, staticRenderFns } from "./TradeVolume.vue?vue&type=template&id=ca766ee4&scoped=true&"
import script from "./TradeVolume.vue?vue&type=script&lang=js&"
export * from "./TradeVolume.vue?vue&type=script&lang=js&"
import style0 from "./TradeVolume.vue?vue&type=style&index=0&id=ca766ee4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca766ee4",
  null
  
)

export default component.exports